import React, {useState, useEffect} from 'react'
import {Card, Button} from 'antd'
import ReactCodeInput from 'react-verification-code-input';
import UserService from "../../API/user/UserService"
import {useHistory} from 'react-router-dom';
import "./Verify.css"
import Navbar from '../../components/layout/Navbar';
import Footer3 from '../../components/layout/Footer3';


function ResetPasswordEmail(props) {
    const [verified, setVerified] = useState(true)
    const [loading, setLoading] = useState({isLoading: false, feedback: null})
    const [code, setCode] = useState([])
    const [toast, setToast] = useState(null)
    const history = useHistory();
    
    var codes = [];

    const email = props?.location?.state?.email || '';
  
   

    const submit = () => {
        setLoading({isLoading: true, feedback: null})
       
        var otp = parseInt(code.join(''))

        UserService.verifyReset(email, otp)
            .then((resp) => {
                setLoading({isLoading: false, feedback: "successfully verified"})
                setVerified(false)
                history.push({
                    pathname: '/resetnew',
                    state: {email: email, token: resp?.data?.accessToken}
                })

            })
            .catch((err) => {
                console.error('Reset OTP verify error:', err?.response?.data || err);
                const msg = 'Invalid code. Please try again.';
                setLoading({isLoading: false, feedback: msg})
                setToast({
                    type: 'error',
                    title: 'Verification failed',
                    message: msg,
                });
            });
    }

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);
   
    return (
        <>
            <Navbar />
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            <div className='auth-page'>
                <div className='auth-card-wrapper'>
                    {verified ? (
                        <Card className='auth-card'>
                            <h1 className='auth-title'>Password Reset</h1>
                            <p className='auth-subtitle'>
                                We just emailed you. Please check your email for the One Time Pin.
                            </p>
                            
                            <p className='auth-email-highlight'>{email}</p>

                            <div className='auth-otp-wrapper'>
                                <ReactCodeInput
                                    values={code}
                                    onChange={(e) => {
                                        codes.push(e)
                                        setCode(codes)
                                    }}
                                />
                            </div>

                            <Button
                                onClick={submit}
                                type="primary"
                                className='auth-btn'
                            >
                                {loading.isLoading ? (
                                    <div className="lds-facebook"><div></div><div></div><div></div></div>
                                ) : "Verify"}
                            </Button>

                            {loading.feedback && (
                                <p className='auth-feedback'>{loading.feedback}</p>
                            )}
                        </Card>
                    ) : (
                        <Card className='auth-card auth-success-card'>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <img
                                    style={{width: '120px', height: '120px'}}
                                    src="check.png"
                                    alt="Success"
                                    className='auth-success-icon'
                                />
                            </div>
                            <p className='auth-success-message'>OTP successfully verified</p>
                        </Card>
                    )}
                </div>
            </div>
            <Footer3 />
        </>
    )
}

export default ResetPasswordEmail;
